/**
 * Perform screenshare-releated actions.
 * @module Screenshare
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import createLog from "./log";
var log = createLog("screenshare");
function getScreenStream($store) {
    return __awaiter(this, void 0, void 0, function () {
        var stream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stream = $store.getters.localScreenStream;
                    if (!!stream) return [3 /*break*/, 2];
                    return [4 /*yield*/, window.navigator.mediaDevices.getDisplayMedia({
                            video: {
                                cursor: "always",
                            },
                            audio: false,
                        })];
                case 1:
                    stream = _a.sent();
                    $store.dispatch("setLocalScreenStream", stream);
                    _a.label = 2;
                case 2: return [2 /*return*/, stream];
            }
        });
    });
}
function configureStreamForScreenAndVideo($store, $socket) {
    return __awaiter(this, void 0, void 0, function () {
        var stream, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getScreenStream($store)];
                case 1:
                    stream = _a.sent();
                    stream.getVideoTracks()[0].addEventListener("ended", function () {
                        // The sharing was ended e.g. by clicking the chrome "Stop Sharing" button.
                        if ($store.getters.sharingScreenAndVideo) {
                            disableScreenAndVideo($store, $socket);
                            $store.dispatch("setLocalScreenStream", null);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    $store.dispatch("setScreenShareError", err_1.message);
                    $store.dispatch("setLocalScreenStream", null);
                    $store.dispatch("updateSharingScreenAndVideo", false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function configureStreamForScreenOnly($store) {
    return __awaiter(this, void 0, void 0, function () {
        var stream, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getScreenStream($store)];
                case 1:
                    stream = _a.sent();
                    $store.dispatch("updateCurrentVideoDevice", { deviceId: "screen" });
                    stream.getVideoTracks()[0].addEventListener("ended", function () {
                        // The sharing was ended e.g. by clicking the chrome "Stop Sharing" button.
                        if ($store.getters.sharingScreenOnly) {
                            disableScreenOnly($store);
                            $store.dispatch("setLocalScreenStream", null);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    $store.commit("screenShareError", err_2.message);
                    $store.dispatch("setLocalScreenStream", null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function enableScreenAndVideo($store, $socket) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ($store.getters.sharingScreenOnly) {
                        disableScreenOnly($store);
                    }
                    // Clear previous screenshare errors
                    $store.dispatch("setScreenShareError", undefined);
                    return [4 /*yield*/, configureStreamForScreenAndVideo($store, $socket)];
                case 1:
                    _a.sent();
                    if (!$store.getters.localScreenStream) {
                        return [2 /*return*/];
                    }
                    $socket.sendWithoutSession("updateSharingState", {
                        enabled: true,
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function disableScreenAndVideo($store, $socket) {
    $socket.sendWithoutSession("updateSharingState", {
        enabled: false,
    });
    $store.dispatch("updateSharingScreenAndVideo", false);
}
export function enableScreenOnly($store, $socket) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ($store.getters.sharingScreenAndVideo) {
                        disableScreenAndVideo($store, $socket);
                    }
                    // Clear previous device and screenshare errors
                    $store.dispatch("setVideoDeviceError", { errorId: undefined, deviceName: undefined });
                    $store.dispatch("setScreenShareError", undefined);
                    return [4 /*yield*/, configureStreamForScreenOnly($store)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function disableScreenOnly($store) {
    $store.dispatch("updateCurrentVideoDevice", { deviceId: undefined });
}
export function stopScreen($store, $socket) {
    if ($store.getters.sharingScreenAndVideo) {
        disableScreenAndVideo($store, $socket);
    }
    else if ($store.getters.sharingScreenOnly) {
        disableScreenOnly($store);
    }
    // Stop screen track
    var stream = $store.getters.localScreenStream;
    if (stream && stream.getVideoTracks()[0]) {
        stream.getVideoTracks()[0].stop();
    }
    $store.dispatch("setScreenShareError", undefined);
    $store.dispatch("setLocalScreenStream", null);
}



//////////////////
// WEBPACK FOOTER
// ./src/screenshare.ts
// module id = 39
// module chunks = 1